import { UsersPickerModalController } from './users-picker-modal.controller';

export const UsersPickerModalComponent: ng.IComponentOptions = {
  bindings: {
    max: '<',
    selectedUsers: '<',
    onClose: '&',
    onSave: '&',
  },
  templateUrl: 'components/UsersPicker/components/modal/users-picker-modal.html',
  controller: UsersPickerModalController,
};
